/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import DigitalCertificateStatus from './DigitalCertificateStatus';

/**
 * The AcademicProgramCertificate model module.
 * @module model/AcademicProgramCertificate
 * @version 1.0.0
 */
class AcademicProgramCertificate {
    /**
     * Constructs a new <code>AcademicProgramCertificate</code>.
     * @alias module:model/AcademicProgramCertificate
     * @param idAttribute {String} 
     * @param idProductAttribute {String} 
     * @param name {String} 
     * @param educationLaws {Array.<Number>} 
     * @param image {String} 
     * @param digital {module:model/DigitalCertificateStatus} 
     */
    constructor(idAttribute, idProductAttribute, name, educationLaws, image, digital) { 
        
        AcademicProgramCertificate.initialize(this, idAttribute, idProductAttribute, name, educationLaws, image, digital);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, idAttribute, idProductAttribute, name, educationLaws, image, digital) { 
        obj['id_attribute'] = idAttribute;
        obj['id_product_attribute'] = idProductAttribute;
        obj['name'] = name;
        obj['education_laws'] = educationLaws;
        obj['image'] = image;
        obj['digital'] = digital;
    }

    /**
     * Constructs a <code>AcademicProgramCertificate</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AcademicProgramCertificate} obj Optional instance to populate.
     * @return {module:model/AcademicProgramCertificate} The populated <code>AcademicProgramCertificate</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AcademicProgramCertificate();

            if (data.hasOwnProperty('id_attribute')) {
                obj['id_attribute'] = ApiClient.convertToType(data['id_attribute'], 'String');
            }
            if (data.hasOwnProperty('id_product_attribute')) {
                obj['id_product_attribute'] = ApiClient.convertToType(data['id_product_attribute'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('education_laws')) {
                obj['education_laws'] = ApiClient.convertToType(data['education_laws'], ['Number']);
            }
            if (data.hasOwnProperty('image')) {
                obj['image'] = ApiClient.convertToType(data['image'], 'String');
            }
            if (data.hasOwnProperty('digital')) {
                obj['digital'] = DigitalCertificateStatus.constructFromObject(data['digital']);
            }
        }
        return obj;
    }


}

/**
 * @member {String} id_attribute
 */
AcademicProgramCertificate.prototype['id_attribute'] = undefined;

/**
 * @member {String} id_product_attribute
 */
AcademicProgramCertificate.prototype['id_product_attribute'] = undefined;

/**
 * @member {String} name
 */
AcademicProgramCertificate.prototype['name'] = undefined;

/**
 * @member {Array.<Number>} education_laws
 */
AcademicProgramCertificate.prototype['education_laws'] = undefined;

/**
 * @member {String} image
 */
AcademicProgramCertificate.prototype['image'] = undefined;

/**
 * @member {module:model/DigitalCertificateStatus} digital
 */
AcademicProgramCertificate.prototype['digital'] = undefined;






export default AcademicProgramCertificate;

